/**
 * markdown 渲染工具（供 AI 助手消息使用）
 *
 * - 动态 import('marked')：未安装 marked 时优雅降级（渲染失败由调用方回退纯文本），不会拖垮整个工程构建。
 * - marked 不内置消毒，这里做一层轻量 HTML 清洗，剥离脚本/事件属性/javascript: 协议。
 *
 * 依赖：package.json 需包含 "marked": "^12.0.2"，使用前执行 npm install 安装。
 */

let markedPromise = null;
let markedInstance = null;

function loadMarked() {
  if (markedInstance) {
    return Promise.resolve(markedInstance);
  }
  if (!markedPromise) {
    markedPromise = import("marked")
      .then((mod) => {
        const lib = mod.marked || mod.default;
        if (!lib || typeof lib.parse !== "function") {
          throw new Error("marked 库格式异常");
        }
        markedInstance = lib;
        return lib;
      })
      .catch((err) => {
        // 加载失败（多半未安装）允许下次重试
        markedPromise = null;
        throw err;
      });
  }
  return markedPromise;
}

/** 是否已可用（同步判断，供 UI 决定先展示原文还是等待渲染） */
export function isMarkdownReady() {
  return !!markedInstance;
}

/**
 * 把 markdown 文本渲染成安全的 HTML；marked 未就绪/失败时抛错，由调用方降级
 * @param {string} text markdown 原文
 * @returns {Promise<string>} 已消毒的 HTML
 */
export async function markdownToHtml(text) {
  const lib = await loadMarked();
  const raw = lib.parse(text || "", { gfm: true, breaks: true });
  return sanitizeHtml(raw);
}

/** 轻量 HTML 清洗：去 script、事件属性、javascript: 协议 */
function sanitizeHtml(html) {
  return html
    .replace(/<\s*script[\s\S]*?<\s*\/\s*script\s*>/gi, "")
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "")
    .replace(/(\s(?:href|src)\s*=\s*["']?)\s*javascript:[^"'\s>]*/gi, "$1");
}
